import Flickity from 'flickity';
import 'flickity-imagesloaded';
import allSlidesVisible from '../SimpleCarousel/allSlidesVisible';

export default (container = document) => {

  const hero_image_galleries = {};
  const hero_image_gallery_navs = {};

  const initCarousel = ($carousel) => {
    const id = $carousel.attr('id');
    let initial_index = 0;

    if (hero_image_galleries[id]) {
      initial_index = hero_image_galleries[id].selectedIndex;
      hero_image_galleries[id].destroy();
      delete hero_image_galleries[id];
    }
  
    if ($carousel.children().length < 2) {
      // Don't init pointless carousels with 1 or no slides
      $carousel.addClass('AnimateOnLoad--loaded');
      return;
    }
  
    hero_image_galleries[id] = new Flickity($carousel[0], {
      initial_index,
      // prevNextButtons: true,
      pageDots: false,
      wrapAround: true,
      setGallerySize: false,
      cellSelector: '[data-slide]',
      // cellAlign: 'center',
      // autoPlay: $carousel.data('autoPlay'),
      // pauseAutoPlayOnHover: $carousel.data('pauseAutoPlayOnHover'),
      adaptiveHeight: false,
      contain: true,
      imagesLoaded: true,
      draggable: true,
      on: {
        ready: () => {
          $carousel.addClass('AnimateOnLoad--loaded');
        },
        change: () => {
          $(document).trigger('notShoppableClick');
          let position = hero_image_galleries[id].selectedIndex + 1;

          if (position < 10) {
            position = `0${position}`;
          }

          $carousel.find('[data-current-position]').html(position);
        },
      },
    });

    const $thumbs = $carousel.siblings().find(`[data-as-nav-for="#${id}"]`);
    const thumbs_id = $thumbs.attr('id');
    const $thumbs_data = $thumbs.data();

    let wrapAround = true;
    let prevNextButtons = true;
    let draggable = true;

    if (allSlidesVisible($thumbs)) {
      wrapAround = false;
      prevNextButtons = false;
      draggable = false;
    }

    hero_image_gallery_navs[thumbs_id] = new Flickity($thumbs[0], {
      asNavFor: $thumbs_data.asNavFor,
      initial_index,
      prevNextButtons,
      wrapAround,
      contain: true,
      pageDots: false,
      cellAlign: 'center',
      draggable,
      setGallerySize: false,
      cellSelector: '[data-slide]',
      on: {
        change: (index) => {
          if (hero_image_galleries[id].selectedIndex !== index) {
            hero_image_galleries[id].select(index);
          }
        },
      },
    });

    $thumbs.parent('.HeroGallery__nav-wrapper').addClass('AnimateOnLoad--loaded');
  };

  $('[data-hero-image-gallery]', container).each((i, gallery) => {
    initCarousel($(gallery));
  });
};